import { RatingSizeType } from '../../../../../../components/rating/types/ratingSizeType';
import { RatingVariantType } from '../../../../../../components/rating/types/ratingVariantType';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../text/variants';
const getCommonRatingElementContainer = (FOUNDATIONS) => {
    return {
        position: 'relative',
        display: 'flex',
        justify_content: 'center',
        align_items: 'center',
    };
};
const getCommonSmallRatingElementIcon = (FOUNDATIONS) => {
    return {
        width: FOUNDATIONS.size_100,
        height: FOUNDATIONS.size_100,
    };
};
const getCommonMediumRatingElementIcon = (FOUNDATIONS) => {
    return {
        width: FOUNDATIONS.size_150,
        height: FOUNDATIONS.size_150,
    };
};
const getCommonRatingElementInput = (FOUNDATIONS) => {
    return {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        cursor: 'default',
    };
};
const getSmallRatingElementStateStyles = (FOUNDATIONS) => {
    const commonRatingElementContainer = getCommonRatingElementContainer(FOUNDATIONS);
    const commonSmallRatingElementIcon = getCommonSmallRatingElementIcon(FOUNDATIONS);
    const commonRatingElementInput = getCommonRatingElementInput(FOUNDATIONS);
    return {
        DEFAULT: {
            container: {
                ...commonRatingElementContainer,
            },
            icon: {
                ...commonSmallRatingElementIcon,
                color: FOUNDATIONS.color_comp_feedback_rating_shape_unselected_bg,
            },
            input: {
                ...commonRatingElementInput,
            },
        },
        SELECTED: {
            container: {
                ...commonRatingElementContainer,
            },
            icon: {
                ...commonSmallRatingElementIcon,
                color: FOUNDATIONS.color_comp_feedback_rating_shape_selected_bg,
            },
            input: {
                ...commonRatingElementInput,
            },
        },
        HOVER: {
            container: {
                ...commonRatingElementContainer,
            },
            icon: {
                ...commonSmallRatingElementIcon,
                width: `calc(${commonSmallRatingElementIcon.width} + 2px)`,
                height: `calc(${commonSmallRatingElementIcon.height} + 2px)`,
                color: FOUNDATIONS.color_comp_feedback_rating_shape_hover_bg,
            },
            input: {
                ...commonRatingElementInput,
            },
        },
        DISABLED: {
            container: {
                ...commonRatingElementContainer,
            },
            icon: {
                ...commonSmallRatingElementIcon,
                color: FOUNDATIONS.color_accent_disabled_icon_100,
            },
            input: {
                ...commonRatingElementInput,
            },
        },
        DISABLED_SELECTED: {
            container: {
                ...commonRatingElementContainer,
            },
            icon: {
                ...commonSmallRatingElementIcon,
                color: FOUNDATIONS.color_accent_disabled_icon_50,
            },
            input: {
                ...commonRatingElementInput,
            },
        },
    };
};
const getMediumRatingElementStateStyles = (FOUNDATIONS) => {
    const commonRatingElementContainer = getCommonRatingElementContainer(FOUNDATIONS);
    const commonMediumRatingElementIcon = getCommonMediumRatingElementIcon(FOUNDATIONS);
    const commonRatingElementInput = getCommonRatingElementInput(FOUNDATIONS);
    return {
        DEFAULT: {
            container: {
                ...commonRatingElementContainer,
            },
            icon: {
                ...commonMediumRatingElementIcon,
                color: FOUNDATIONS.color_comp_feedback_rating_shape_unselected_bg,
            },
            input: {
                ...commonRatingElementInput,
            },
        },
        SELECTED: {
            container: {
                ...commonRatingElementContainer,
            },
            icon: {
                ...commonMediumRatingElementIcon,
                color: FOUNDATIONS.color_comp_feedback_rating_shape_selected_bg,
            },
            input: {
                ...commonRatingElementInput,
            },
        },
        HOVER: {
            container: {
                ...commonRatingElementContainer,
            },
            icon: {
                ...commonMediumRatingElementIcon,
                width: `calc(${commonMediumRatingElementIcon.width} + 2px)`,
                height: `calc(${commonMediumRatingElementIcon.height} + 2px)`,
                color: FOUNDATIONS.color_comp_feedback_rating_shape_hover_bg,
            },
            input: {
                ...commonRatingElementInput,
            },
        },
        DISABLED: {
            container: {
                ...commonRatingElementContainer,
            },
            icon: {
                ...commonMediumRatingElementIcon,
                color: FOUNDATIONS.color_accent_disabled_icon_100,
            },
            input: {
                ...commonRatingElementInput,
            },
        },
        DISABLED_SELECTED: {
            container: {
                ...commonRatingElementContainer,
            },
            icon: {
                ...commonMediumRatingElementIcon,
                color: FOUNDATIONS.color_accent_disabled_icon_50,
            },
            input: {
                ...commonRatingElementInput,
            },
        },
    };
};
export const getReadOnlyStyles = (FOUNDATIONS, FONT) => {
    return {
        [RatingVariantType.READ_ONLY]: {
            [RatingSizeType.SMALL]: {
                rootContainer: {
                    display: 'flex',
                    flex_direction: 'row',
                    justify_content: 'start',
                    align_items: 'center',
                    gap: FOUNDATIONS.spacing_150,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_350,
                    color: FOUNDATIONS.color_neutral_font_50,
                    font_weight: FONT_WEIGHT.font_regular,
                },
                ratingElementsContainer: {
                    display: 'flex',
                    flex_direction: 'row',
                    justify_content: 'start',
                    align_items: 'center',
                    gap: FOUNDATIONS.spacing_100,
                },
                ratingElementStateStyles: getSmallRatingElementStateStyles(FOUNDATIONS),
            },
            [RatingSizeType.MEDIUM]: {
                rootContainer: {
                    display: 'flex',
                    flex_direction: 'row',
                    justify_content: 'start',
                    align_items: 'center',
                    gap: FOUNDATIONS.spacing_150,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_200,
                    color: FOUNDATIONS.color_neutral_font_50,
                    font_weight: FONT_WEIGHT.font_regular,
                },
                ratingElementsContainer: {
                    display: 'flex',
                    flex_direction: 'row',
                    justify_content: 'start',
                    align_items: 'center',
                    gap: FOUNDATIONS.spacing_100,
                },
                ratingElementStateStyles: getMediumRatingElementStateStyles(FOUNDATIONS),
            },
        },
    };
};
//# sourceMappingURL=readOnly.js.map